<template>
  <div class="se-main-container">
  <div> <img width="150px" src="../../../assets/session-expired-icon.png" alt="" /></div>
<div class="se-header">Your session expired</div>
<div class="se-message">
    Your session has expired. Please login again to continue your work.
    </div>
<div class="se-btn-container">
     <button  @click="redirectToLogin" class="se-btn e-control e-btn e-lib e-info">Login</button>
     </div>
  </div>
</template>

<script>

export default {
  name: "SessionExpired",
  methods: {
    redirectToLogin() {
      this.$router.push('/login');
    },
  },
};
</script>
<style>
.se-main-container {
    text-align: center;
    height: 100%;
    padding-right: 20%;
    padding-top: 30px;
}
.se-header {
    font-size: 26px;
    font-weight: 600;
    padding: 10px;
}
.se-message {
    max-width: 330px;
    margin: 0 auto;
}
.se-btn-container {
    margin-top: 30px;
}
</style>
